import { useI18n } from '@affine/i18n';
import { type FC } from 'react';

import * as styles from './settings-editor-scope-hint.css';

export const SettingsEditorScopeHint: FC = () => {
  const t = useI18n();

  return (
    <div className={styles.hint}>
      {t['com.streamlain.settings.workspace.editor-scope-hint']()}
    </div>
  );
};
